module.exports = __webpack_public_path__ + "static/img/client5.1e08d70c.jpg";